import { IRootState } from "@store/store";
import { GetterTree } from "vuex";
import { IProjectTeamPopupsState } from "./Interfaces";

export const getters: GetterTree<IProjectTeamPopupsState, IRootState> = {
    addMemberPopupToggler: (state): boolean => state.addMemberPopupToggler,
    rolesPopupToggler: (state): boolean => state.rolesPopupToggler,
}
